import { iBooking } from "@sdk/bookings/booking-model";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";

export const {
  selectQueryMap: selectBookingQueryMap,
  selectEntityMap: selectBookingsMap,
  selectQueryMapAll: selectBookingsMapAll,
  selectQueryAllList: selectBookingsAllList,
  selectAllEntities: selectAllBookings,
  selectAllEntitiesQuery: selectAllBookingsQuery,
  selectEntityById: selectBookingById,
  selectEntityQuery: selectBookingQuery,
  selectEntityQueryList: selectBookingQueryList,
} = CreateSelectorForEntities<iStore, iBooking>({
  sliceName: "bookings",
});
